import { useState, useEffect } from "react"

export const useProgressiveImage = (src: any, isVisible: boolean) => {
  const [sourceLoaded, setSourceLoaded] = useState(null)
  useEffect(() => {
    if (sourceLoaded || !isVisible || !src) return


    // console.log('useProgressiveImage')
    const img = new Image()
    img.src = src.fluid?.src
    img.onload = () => {
      // console.log('img.onload loaded')
      setSourceLoaded(src)
    }
  }, [src, isVisible])

  return sourceLoaded
}